import { Box, Collapse, List } from "@mui/material";
import React, { useReducer } from "react";
import { Link as RouterLink } from "react-router-dom";
import { Outlet } from "react-router-dom";
import { TOOLBAR_HEIGHT, NAV_LINKS } from "../../consts";
import { PALETTE } from "../../styles/theme";
import SiteFooter from "./SiteFooter";
import SiteHeader from "./SiteHeader";
const MobileLayout = (props) => {
    const { scrollRef } = props;
    const [drawerOpen, toggleDrawer] = useReducer((prev) => !prev, false);
    return (React.createElement(Box, { sx: {
            width: "100%",
            minHeight: "100dvh",
            display: "flex",
            flexDirection: "column",
        } },
        React.createElement(SiteHeader, { menuOpen: drawerOpen, onMenuToggle: toggleDrawer, hideMobileNav: true, hideLogo: true }),
        React.createElement(Collapse, { in: drawerOpen },
            React.createElement(List, { sx: {
                    // backgroundColor: PALETTE.primary.main,
                    // color: PALETTE.primary.contrastText,
                    minHeight: `calc(100dvh - ${TOOLBAR_HEIGHT})`,
                    borderColor: PALETTE.primary.contrastText,
                    borderTop: 1,
                    width: "100%",
                    maxWidth: "100vw",
                }, disablePadding: true }, NAV_LINKS.map((link) => (React.createElement(Box, { key: link.to, component: RouterLink, to: `/${link.to}`, onClick: toggleDrawer, sx: {
                    display: "block",
                    py: 2.5,
                    px: 3,
                    fontFamily: "'Jost', sans-serif",
                    fontSize: "0.85rem",
                    fontWeight: 500,
                    letterSpacing: "0.1em",
                    textTransform: "uppercase",
                    textDecoration: "none",
                    color: "inherit",
                    borderBottom: `1px solid ${PALETTE.primary.contrastText}22`,
                } }, link.label))))),
        React.createElement(Box, { sx: {
                flex: 1,
                minHeight: 0,
                width: "100%",
                maxWidth: "100vw",
                display: "flex",
                flexDirection: "column",
                visibility: drawerOpen ? "hidden" : "visible",
            } },
            React.createElement(Box, { sx: {
                    flex: 1,
                    minHeight: 0,
                    width: "100%",
                } },
                React.createElement(Box, { ref: scrollRef }),
                React.createElement(Outlet, null)),
            React.createElement(SiteFooter, null))));
};
export default MobileLayout;
